import { render, staticRenderFns } from "./Synthesis.vue?vue&type=template&id=6d0f0161&"
import script from "./Synthesis.vue?vue&type=script&lang=js&"
export * from "./Synthesis.vue?vue&type=script&lang=js&"
import style0 from "./Synthesis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/_AzureDevOps/Kali_easyfert/CMS/Web/easyfert/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout})
